import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
interface ProductMetadata {
  stacklineSku: string;
  title: string;
  retailerSku: string;
  imageUrl?: string;
  [key: string]: unknown;
}

const useProductMetaData = ({
  skusToFetch,
  retailerId,
  enabled
}: {
  skusToFetch: string[];
  retailerId: number;
  enabled: boolean;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: [skusToFetch],
    queryFn: async () => {
      if (!skusToFetch.length) return {};

      const { data: response } = await axios.post<ProductMetadata[]>('/api/atlas/GetEntityMetadataInBulk', {
        entityType: 'product',
        entityIds: skusToFetch,
        retailerId
      });

      return response.reduce((acc, product) => {
        acc[product.stacklineSku] = product;
        return acc;
      }, {} as Record<string, ProductMetadata>);
    },
    enabled
  });

  return { data, isLoading };
};

export default useProductMetaData;
